import { FormField } from 'src/components/Form/types';

export const formFields: FormField[] = [
  {
    name: 'first_name',
    type: 'text',
    placeholder: 'שם פרטי',
    validation: {
      maxLength: { value: 100, message: 'אורך מקסימלי 100 תווים' },
    },
  },
  {
    name: 'vendor',
    type: 'text',
    placeholder: 'שם משפחה',
    validation: {
      maxLength: { value: 100, message: 'אורך מקסימלי 100 תווים' },
    },
  },
  {
    name: 'vendor',
    type: 'text',
    placeholder: 'כתובת אימייל',
  },
  {
    name: 'vendor',
    type: 'text',
    placeholder: 'טלפון',
  },
];
